import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

interface TimelineRowProps {
    title: string;
    startDate: string;
    endDate: string;
    color: string;
}

const TimelineRow: React.FC<TimelineRowProps> = ({ title, startDate, endDate, color }) => {
    return (
        <Flex align="center" mb="6px" p={2} borderRadius="md" boxShadow="sm" _hover={{ bg: "#E6E7E8" }}>
            
            <Box mr={6}>
                {color === "#115E42" ? (
                    <FaCheckCircle color="#115E42" />
                ) : (
                    <FaExclamationCircle color="#962324" />
                )}
            </Box>
            <Box flex="1">
                <Text fontWeight="bold" textAlign="left">{title}</Text>
                <Flex direction="column" fontSize="sm" color="#414042" mt={2}>
                    <Flex alignItems="center">
                        <Box w="8px" h="8px" bg="#115E42" borderRadius="full" mr={2} />
                        <Text>Start: {new Date(startDate).toLocaleString()}</Text>
                    </Flex>
                    <Flex alignItems="center">
                        <Box w="8px" h="8px" bg="#962324" borderRadius="full" mr={2} />
                        <Text>Fine: {new Date(endDate).toLocaleString()}</Text>
                    </Flex>
                </Flex>
            </Box>
        </Flex>
    );
};

export default TimelineRow;